/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateStorefrontScriptsRequestInnerScripts } from './UpdateStorefrontScriptsRequestInnerScripts';
import {
    UpdateStorefrontScriptsRequestInnerScriptsFromJSON,
    UpdateStorefrontScriptsRequestInnerScriptsFromJSONTyped,
    UpdateStorefrontScriptsRequestInnerScriptsToJSON,
    UpdateStorefrontScriptsRequestInnerScriptsToJSONTyped,
} from './UpdateStorefrontScriptsRequestInnerScripts';

/**
 * 
 * @export
 * @interface UpdateStorefrontScriptsRequestInner
 */
export interface UpdateStorefrontScriptsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInner
     */
    id: string;
    /**
     * 
     * @type {UpdateStorefrontScriptsRequestInnerScripts}
     * @memberof UpdateStorefrontScriptsRequestInner
     */
    scripts: UpdateStorefrontScriptsRequestInnerScripts;
}

/**
 * Check if a given object implements the UpdateStorefrontScriptsRequestInner interface.
 */
export function instanceOfUpdateStorefrontScriptsRequestInner(value: object): value is UpdateStorefrontScriptsRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('scripts' in value) || value['scripts'] === undefined) return false;
    return true;
}

export function UpdateStorefrontScriptsRequestInnerFromJSON(json: any): UpdateStorefrontScriptsRequestInner {
    return UpdateStorefrontScriptsRequestInnerFromJSONTyped(json, false);
}

export function UpdateStorefrontScriptsRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStorefrontScriptsRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'scripts': UpdateStorefrontScriptsRequestInnerScriptsFromJSON(json['scripts']),
    };
}

export function UpdateStorefrontScriptsRequestInnerToJSON(json: any): UpdateStorefrontScriptsRequestInner {
    return UpdateStorefrontScriptsRequestInnerToJSONTyped(json, false);
}

export function UpdateStorefrontScriptsRequestInnerToJSONTyped(value?: UpdateStorefrontScriptsRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'scripts': UpdateStorefrontScriptsRequestInnerScriptsToJSON(value['scripts']),
    };
}

